var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-user-selected"},[_c('i',{staticClass:"fi-torso"}),_c('div',[_vm._v("Nincs felhasználó kiválasztva")])])
}]

export { render, staticRenderFns }